/**
 * Modal público de bases y condiciones del sorteo.
 */
import React, { useEffect } from "react";
import {
  SORTEO_BASES_META,
  SORTEO_BASES_SECTIONS,
} from "./sorteoPublicCopy";

export default function SorteoBasesModal({ open, onClose }) {
  useEffect(() => {
    if (!open) return undefined;
    const onKeyDown = (event) => {
      if (event.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKeyDown);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKeyDown);
      document.body.style.overflow = prevOverflow;
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="expdl-modal-backdrop expdl-bases-backdrop"
      role="presentation"
      onClick={onClose}
    >
      <div
        className="expdl-modal expdl-bases-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="expdl-bases-title"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="expdl-bases-header">
          <h2 id="expdl-bases-title" className="expdl-modal-title">
            {SORTEO_BASES_META.title}
          </h2>
          <p className="expdl-bases-subtitle">{SORTEO_BASES_META.subtitle}</p>
          <p className="expdl-bases-section-heading">
            {SORTEO_BASES_META.sectionTitle}
          </p>
        </div>

        <div className="expdl-bases-body">
          {SORTEO_BASES_SECTIONS.map((section) => (
            <section
              key={`${section.number}-${section.title}`}
              className="expdl-bases-section"
            >
              <h3 className="expdl-bases-section-title">
                <span className="expdl-bases-section-num">{section.number}.</span>{" "}
                {section.title}
              </h3>

              {section.paragraphs?.map((paragraph) => (
                <p key={paragraph} className="expdl-bases-paragraph">
                  {paragraph}
                </p>
              ))}

              {section.intro ? (
                <p className="expdl-bases-paragraph">{section.intro}</p>
              ) : null}

              {section.bullets?.length ? (
                <ul className="expdl-bases-bullets">
                  {section.bullets.map((bullet) => (
                    <li key={bullet}>{bullet}</li>
                  ))}
                </ul>
              ) : null}

              {section.outro ? (
                <p className="expdl-bases-paragraph">{section.outro}</p>
              ) : null}
            </section>
          ))}
        </div>

        <div className="expdl-modal-actions">
          <button type="button" className="expdl-submit" onClick={onClose}>
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
}
